export default __webpack_public_path__ + "static/media/q2_05.688e6e1e.png";